import React, { useState, useEffect, useCallback } from 'react';
import {  Typography, Divider, Paper, Grid, Box, TextField } from '@mui/material';
import { useSnackbar } from 'notistack';
import MobileDateRangePicker from '@mui/lab/MobileDateRangePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { buildTableDataAndColumns, getConstDbFormat } from 'utils/common';
import LibrarySelect from 'components/librarySelect';
import { getBookingReport } from 'services/reports';
import ReactDataTableBuilder from 'components/tableBuilder'

const BookingsReport = () => {

  const [ filterDates, setFilterDates] = useState([new Date(), new Date()]);
  const [reportsData, setReportsData] = useState([]);
  const [selectedLibrary, setSelectedLibrary] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [tableData, setTableData] = useState(false);

  useEffect(() => {
    const [fromDate,  toDate] = filterDates;
    if(fromDate && toDate && selectedLibrary){
      getReportData(filterDates,  selectedLibrary);
    }
  }, [filterDates, selectedLibrary]);

  const onLibrarySelected = useCallback((lib) => {
    setSelectedLibrary({...lib});
  },[]);
  

  function getReportData(filterDates,  selectedLibrary) {
    const [fromDate,  toDate] = filterDates;
    const reqData = {
      fromDate: getConstDbFormat(fromDate),
      toDate: getConstDbFormat(toDate),
      propertyId: selectedLibrary?.libraryId,
      propertyType: 'LIBRARY'
    };

    getBookingReport(reqData).then(({response, error}) => {
      if(response){
        setReportsData(response);
      } else {
        setReportsData([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  function onDateAccepted(data) {
    const [fromDate,  toDate] = data;
    if((fromDate && toDate)) {
      setFilterDates([...data]);
    }else{
      setFilterDates(null);
      enqueueSnackbar(`Select ${fromDate === null ? 'From Date' : 'To Date'}`, {variant: 'error'});
    }
  }

  function buildTableColumns() {
    const columns=[
      {name: "Libary Name", key: "library.name", dataKey: 'libraryName', columnOptions: {width: 200}},
      {name: "Booking ID", key: "bookingId", columnOptions: {width: 220}},
      {name: "Seats", key: "seatIds", columnOptions: {width: 140}},
      {name: "Seat Count", key: "seatCount", columnOptions: {width: 115}},
      {name: "From Date", key: "fromDate", columnOptions: {width: 110}},
      {name: "To Date", key: "toDate", columnOptions: {width: 110}},
      {name: "From Time", key: "fromTime", columnOptions: {width: 115}},
      {name: "To Time", key: "toTime", columnOptions: {width: 110}},
      {name: "Cancelled", key: "cancelled", columnOptions: {width: 110, render:({ value }) => value ? "Yes" : "No"}},
      {name: "Cancellation Reason", key: "cancellationReason", columnOptions: {width: 350}},
      {name: "Booked By", key: "user.displayName", dataKey: 'bookedBy'},
      {name: "Mobile", key: "user.mobile", dataKey: 'mobile'},
      {name: "Email", key: "user.email", dataKey: 'email', columnOptions: {width: 170}},
      {name: "Amount", key: "bookingTransaction.amount", dataKey: 'bookingAmount', columnOptions: {width: 100}},
    ];
    return columns;
  };

  function buildTable(data) {
    const columns = buildTableColumns(data);
    const tData = buildTableDataAndColumns(columns,data);
    setTableData({...tData});
  }

  useEffect(() => {
    if(Array.isArray(reportsData) && reportsData.length > 0){
      buildTable(reportsData);
    }else{
      setTableData({});
    }
  }, [reportsData]);
  

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
    {/* <CardContent> */}
      <Typography component="h2" variant="h6" color="secondary" gutterBottom>
        Bookings Report
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container spacing={3} alignItems="center"  direction="row" >
          <Grid container item xs={12} sm={12} md={12} xl={12} lg={12} sx={{ p: '0.8rem !important', ml: 2, mt:3, bgcolor: "#f3f3f3"}} rowSpacing={1}>
            {/* <Paper elevation={0} sx={{p:1, bgcolor: "#f3f3f3"}}> */}
              <Grid item xs={12} sm={12} md={12} xl={12} lg={12}  >
                <Typography variant="subtitle2"  component="div">
                Filters
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={6} xl={6} lg={6}  sx={{mt: 1.4}}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MobileDateRangePicker
                    startText="From Date"
                    endText="To Date"
                    value={filterDates}
                    inputFormat="dd/MM/yyyy"
                    onChange={(newValue) => {
                      return newValue;
                    }}
                    onAccept={(data) => onDateAccepted(data)}
                    renderInput={(startProps, endProps) => (
                      <React.Fragment>
                        <TextField {...startProps} size="small" onKeyDown={(e) => {e.preventDefault();return false}}/>
                        <Box sx={{ mx: 1 }}> to </Box>
                        <TextField {...endProps} size="small" onKeyDown={(e) => {e.preventDefault();return false}} />
                      </React.Fragment>
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12} sm={12} md={6} xl={6} lg={6}  sx={{mt: 1.4, display: 'flex',justifyContent: {md: 'end'}}}>
                <LibrarySelect variant="outlined" onLibrarySelected={onLibrarySelected} />
              </Grid>
            {/* </Paper> */}
          </Grid>
          <Grid item xs={12} sm={12} md={12} xl={12} lg={12} >
            {tableData ? <ReactDataTableBuilder id="bookingsTable" minHeight={500} tableData={tableData} downloadFileName="bookings_report" /> : null}
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
 
export default BookingsReport;
